export default {
  install(Vue) {
    Vue.prototype.$generateAbsolutePath = function (path) {
      return process.env.VUE_APP_API_SERVER_URL + path;
    }
  }
}
